var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"apply-status-tag-comp",class:[_vm.calcStatusClass(_vm.status)]},[_vm._v(" "+_vm._s(_vm.statusLabel)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }